module.exports = __webpack_public_path__ + "img/Notification.9af58263.png";